module.exports = __webpack_public_path__ + "img/7_104.b5031693.png";